export const RetornaDominio = (email: string) => {
  let expr: string = '/^([^]+)@(\w+).(\w+)$/';
  let email_analizado = /^([^]+)@(\w+).(\w+)$/.exec(email);
  return email_analizado;
}

export function formatDate(fecha: Date) {
  let dformat = fecha.getFullYear() +
    '-' +
    padLeft(fecha.getMonth() + 1) +
    '-' +
    padLeft(fecha.getDate());
  return dformat;
}

function padLeft(n: any) {
  return ('00' + n).slice(-2);
}